import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__field_connectable_type } from '../_base/_methods/ENUM__field_connectable_type';
import { FIELD__base } from '../_base/FIELD__base';
import { FIELD__list_base_generic } from '../_primitives/list/FIELD__list_base_generic';

export class FIELD__any__list extends FIELD__list_base_generic<FIELD__base> {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_ANY__LIST;

  /*
   *
   */

  field_connectable__type(): ENUM__field_connectable_type {
    return ENUM__field_connectable_type.ANY__LIST;
  }

  field_connectable__value(graph: DTO_GRAPH__instance): string {
    return '';
  }

  /*
   *
   */

  constructor() {
    super();
    this.item_connectable_type = ENUM__field_connectable_type.ANY;
  }

  is_field_is_compatible_to_sync_with(other: FIELD__base): boolean {
    if (!(other instanceof FIELD__list_base_generic)) return false;

    return true;
  }
}
